import { useState } from "react";
import { Question, CaretDown } from "@phosphor-icons/react";

export function PageGuide({ title = "How this works", steps = [], testid }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border border-border bg-card/60" data-testid={testid || "page-guide"}>
      <button onClick={() => setOpen(!open)} data-testid="guide-toggle"
        className="w-full flex items-center gap-2 px-4 py-3 text-left hover:bg-secondary/50 transition-colors duration-200">
        <Question size={18} weight="bold" className="text-primary" />
        <span className="text-sm font-medium">{title}</span>
        <CaretDown size={16} className={`ml-auto text-muted-foreground transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <ol className="px-4 pb-4 pt-1 space-y-2">
          {steps.map((s, i) => (
            <li key={i} className="flex gap-3 text-sm text-muted-foreground">
              <span className="shrink-0 h-5 w-5 flex items-center justify-center bg-primary/15 border border-primary/30 text-primary font-mono text-xs">{i + 1}</span>
              <span>{s}</span>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
